import { Tabs, Tab, Divider, Box } from "@mui/material";
import { FC, useMemo } from "react";
import { useLocation, matchPath } from "react-router";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import { Content } from "~/components/content/Content";
import withCompositeResource, { WrappedComponentProps } from "~/components/recource/CompositeResource";
import { usePermissionsOptimized } from "ra-core";
import { allowDataAccessSettingRoute } from "~/authProvider/permissionMap";


const GovernanceSettings: FC<WrappedComponentProps> = ({
  children,
  tabs,
  options,
}) => {
  const { permissions } = usePermissionsOptimized()
  const location = useLocation()
  const { rest: activeItem } = 
    matchPath<{rest:string}>(location.pathname, { path: '/settings/governance/:rest'})?.params || {}

  const allowedTabs = useMemo(() => tabs.filter(tab => allowDataAccessSettingRoute(tab.primaryPath || tab.path, permissions ?? [])), [tabs, permissions])

  return (
    <Content pageName="Data Access Settings" resourceName="Data Access Settings" breadcrumbs={options?.breadcrumbs} >
      <Helmet>
        <title>Governance Settings | OnData</title>
      </Helmet>
      <Tabs
        indicatorColor="primary"
        scrollButtons="auto"
        textColor="primary"
        variant="scrollable"
        value={`/settings/governance/${activeItem}`}
      >
        {allowedTabs.map((tab) => (
          <Tab
            component={Link}
            key={tab.path}
            label={tab.label}
            value={tab.path}
            to={tab.primaryPath || tab.path}
          />
        ))}
      </Tabs>
      <Divider />
      <Box sx={{ mt: 1, mx: -3 }}>
        {children}
      </Box>
    </Content>
  )
}

export const GovernanceSettingsComposite = withCompositeResource(GovernanceSettings);
